import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";
import "./mitglieder.scss"

const Mitglieder = () => {

    const [mitglieder, setMitglieder] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const mitgliederRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/mitglieder?per_page=100&orderby=title&order=asc`);
                if (mitgliederRes.data && mitgliederRes.data.length > 0) {
                    setMitglieder(mitgliederRes.data);
                }
                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    // Gruppieren nach Register
    const gruppiertNachRegister = mitglieder.reduce((acc, mitglied) => {
        const register = mitglied.acf.register || "Alle Anderen";
        if (!acc[register]) {
            acc[register] = [];
        }
        acc[register].push(mitglied);
        return acc;
    }, {});

    // Nach Register numerisch sortieren
    const sortierteRegister = Object.entries(gruppiertNachRegister).sort(([a], [b]) => {
        return parseInt(a) - parseInt(b);
    });

    return (
        <div className="mitglieder">
            <Helmet>
                <title>Mitglieder | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <motion.div
                className="header"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <h1>Mitglieder</h1>
                <p>Unsere Kapelle besteht seit über 200 Jahren. Dabei vervolgte die Kapelle stets das Ziel, die Musik und die Tradition unserer Heimat lebendig zu halten und gleichzeitig Raum für Neues zu schaffen. Der Zusammenhalt und die Freundschaft unter den Mitgliedern macht unsere Gemeinschaft zu etwas Besonderem.</p>
            </motion.div>
            <div className="container">
                {!isLoading && sortierteRegister.map(([registerName, gruppe]) => (
                    <div key={registerName} className="registerGroup">
                        <h2 className="registerTitle">{registerName.substring(2)}</h2>
                        <div className="grid">
                            {gruppe.map((mitglied, index) => {
                                const delay = (index % 5) * 0.1;

                                return (
                                    <motion.div
                                        className="item"
                                        key={mitglied.id}
                                        initial={{ opacity: 0, y: 100 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay }}
                                    >
                                        <div className="popUp">
                                            <div className="content">
                                                <div className="top">
                                                    <h2>{mitglied.title.rendered}</h2>
                                                    {mitglied.acf.spitzname && <span className="spitzname">"{mitglied.acf.spitzname}"</span>}
                                                    <br />
                                                    {mitglied.acf.mitglied_seit && <span className="value">Mitglied seit {mitglied.acf.mitglied_seit}</span>}
                                                    <br />
                                                    {mitglied.acf.funktion && <span className="value">{mitglied.acf.funktion}</span>}
                                                </div>
                                                <div className="abzeichen">
                                                    {mitglied.acf.abzeichen.map((abzeichen, index) => (
                                                        <img
                                                            key={index}
                                                            src={`/assets/abzeichen/${abzeichen}.png`}
                                                            alt={abzeichen}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        {mitglied.acf.image
                                            ? <img src={mitglied.acf.image} alt={mitglied.title.rendered} />
                                            : <div className="empty"><img src="/assets/harfe.svg" alt="Harfe" /><h2>{mitglied.title.rendered}</h2></div>
                                        }
                                    </motion.div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
};

export default Mitglieder;